import { supabase } from '@/lib/supabaseClient'

export async function fetchMilestones(projectId) {
  const { data, error } = await supabase
    .from('project_milestones')
    .select('*')
    .eq('project_id', projectId)
    .order('display_order', { ascending: true })

  if (error) throw error
  return data
}

export async function createMilestone(milestone) {
  const { data: { user } } = await supabase.auth.getUser()

  const { data, error } = await supabase
    .from('project_milestones')
    .insert({
      ...milestone,
      created_by: user?.id,
    })
    .select()
    .single()

  if (error) throw error
  return data
}

export async function updateMilestone(id, updates) {
  const { data, error } = await supabase
    .from('project_milestones')
    .update(updates)
    .eq('id', id)
    .select()
    .single()

  if (error) throw error
  return data
}

export async function deleteMilestone(id) {
  const { error } = await supabase
    .from('project_milestones')
    .delete()
    .eq('id', id)

  if (error) throw error
}

export async function toggleMilestoneComplete(id, isCompleted) {
  const updates = {
    is_completed: isCompleted,
    completed_date: isCompleted ? new Date().toISOString().split('T')[0] : null,
  }

  const { data, error } = await supabase
    .from('project_milestones')
    .update(updates)
    .eq('id', id)
    .select()
    .single()

  if (error) throw error
  return data
}

export async function reorderMilestones(projectId, orderedIds) {
  const updates = orderedIds.map((id, index) => ({
    id,
    display_order: index,
  }))

  const { error } = await supabase
    .from('project_milestones')
    .upsert(updates, { onConflict: 'id' })

  if (error) throw error
}
